"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.ShopCarouselType=void 0;var r;(function(e){e.CollectionGroup="CollectionGroup",e.EasyReorder="EasyReorder",e.Other="Other",e.TopSellers="TopSellers"})(r||(exports.ShopCarouselType=r={}));
//# sourceMappingURL=ShopCarouselType.js.map
